module.exports = __webpack_public_path__ + "img/elem1Image.9d4fce3b.png";